<template>
    <div class="mobile-search-container">
        <div :class="formClass" v-if="show">
            <div class="form-wrapper clearfix">
                <label class="d-inline-block d-sm-none">
                    <i class="icon-search"></i>
                </label>
                <form class="form-inline">
                    <input autocomplete="off" type="text" class="form-control" :placeholder="$t('app.searchPlaceholder')" name="search" @keyup="search" @keydown.enter.prevent="onEnter" v-model="query" ref="input">
                </form>
                <label @click="toggleForm">
                    <i class="icon-close"></i>
                </label>
            </div>
            <header-search-results v-if="results && results.length" :results="results" :query="query" width="12"></header-search-results>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import HeaderSearchResults from './HeaderSearchResults.vue'

export default {

    components: {
        HeaderSearchResults
    },

    props: {
        src: {
            default: '/search'
        }
    },

    data() {
        return {

            show: false,
            query: null,
            results: null

        }
    },

    computed: {

        formClass() {
            return 'search-form' + (this.show ? ' show' : '');
        }

    },

  methods: {

    toggleForm () {

      this.show = ! this.show;

      if (this.show) {
        Vue.nextTick(() => this.$refs.input.focus())
      } else {
        this.results = null
        this.query = null
      }
    },

    async search () {
      this.results = this.query.length >= 2
        ? await new App.xhr({ query: this.query }).post(this.src)
        : null;
    },

    onEnter () {
      window.location = window.App.url + '/'+App.vue.$options.lang.$t('routes.category')+'?page=1&query=' + this.query
    }

  },

  mounted () {
    App.dispatcher.listen('mobile-search.open', () => {
      this.show = true
      Vue.nextTick(() => this.$refs.input.focus())
    })

    for (let el of document.querySelectorAll('*[data-role="mobile-search.open"]')) {
      el.addEventListener('click', () => App.dispatcher.fire('mobile-search.open'), false)
    }
  }

}
</script>
